/**
 * @enum {String}
 */
export const PLATFORMS = {
  ADMINISTRATION: "ADMINISTRATION",
  DEPARTMENT: "DEPARTMENT",
  STAFF: "STAFF",
  CITIZEN: "CITIZEN",
  DISTRICT: "DISTRICT"
};
